<template>
  <div class="mobilityProduct">
    products
  </div>
</template>

<script>
export default {
  name: 'MobilityProduct',
  props: [
    'locale',
    'product'
  ],
  components: {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
